import React, { useCallback } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useCategoryRequest } from '../../hooks/categoryRequest';

interface FormData {
  name: string;
  photoFilename: string;
}

interface CreateCategoryProps {
  setDialogOpen: (open: boolean) => void;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  photoFilename: yup.string().required("Photo filename is required")
});

const CreateCategory: React.FC<CreateCategoryProps> = ({ setDialogOpen }) => {
  const categoryRequest = useCategoryRequest();
  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = useCallback(async (data: FormData) => {
    const dispatchData = await categoryRequest({ method: 'POST', data, slug: null, query: null });
    if (dispatchData.meta.requestStatus === 'fulfilled') {
      setDialogOpen(false);
      await categoryRequest({ method: 'GET', data: null, slug: null, query: null });
    }
  }, [categoryRequest, setDialogOpen]);

  return (
    <DialogContent sx={{ width: 350 }}>
      <DialogTitle sx={{ p: 0 }}>Add New Category</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Controller
          name="name"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="Name"
              variant="standard"
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : ''}
              fullWidth
              margin="normal"
            />
          )}
        />
        <Controller
          name="photoFilename"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="File Name"
              variant="standard"
              error={!!errors.photoFilename}
              helperText={errors.photoFilename ? errors.photoFilename.message : ''}
              fullWidth
              margin="normal"
            />
          )}
        />
        <Box sx={{ display: 'flex' ,justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Button sx={{ mr: 2 }} onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">Save</Button>
        </Box>
      </form>
    </DialogContent>
  );
}

export default CreateCategory;
